import * as c from 'models/constants';
import { IUserCardAction } from 'models/user/usercard';
import React = require('react');

export const changeTabAndGetRequiredDataFunction = (
	e: React.SyntheticEvent,
	selectedTab: string,
	userId: string,
	action: (selectedTab: string, userId: string) => IUserCardAction,
) => {
	if (e) {
		e.preventDefault();
	}
	if (selectedTab === c.USERCARD_TAB_OVERVIEW && document.querySelector('.profile')) {
		document.documentElement.scrollTop += document.querySelector('.profile').getBoundingClientRect().top;
	}

	action(selectedTab, userId);
};
